import { render, staticRenderFns } from "./OrderFeeDistributionChart.vue?vue&type=template&id=993c70ca&scoped=true"
import script from "./OrderFeeDistributionChart.vue?vue&type=script&lang=js"
export * from "./OrderFeeDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./OrderFeeDistributionChart.vue?vue&type=style&index=0&id=993c70ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993c70ca",
  null
  
)

export default component.exports